import axios from 'axios';
import { AppTrackCheckIn } from '../models/AppTrackCheckIn';

const API_URL = process.env.REACT_APP_SERVER_URL + "/app/track/checkins";

const authHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem('gpcwstoken_kw')}`,
});

export const AppTrackCheckInService = {
    getTrackCheckInsPaginated: async (
        page: number,
        limit: number,
        search?: string,
        userId?: string | number,
        fromDate?: string,
        toDate?: string,
        warehouseId?: string | number
    ): Promise<{ checkins: AppTrackCheckIn[]; total: number }> => {
        const params: Record<string, any> = { page, limit };
        if (search) params.search = search;
        if (userId !== undefined && userId !== null && userId !== '') params.userId = userId;
        if (fromDate) params.fromDate = fromDate;
        if (toDate) params.toDate = toDate;
        if (warehouseId !== undefined && warehouseId !== null && warehouseId !== '') params.warehouseId = warehouseId;
        const response = await axios.get(`${API_URL}/getCheckInsPaginated`, { params, headers: authHeader() });
        return response.data;
    },
    getAllTrackCheckIns: async (): Promise<AppTrackCheckIn[]> => {
        const response = await axios.get(`${API_URL}/getAllCheckIns`, { headers: authHeader() });
        return response.data;
    },

    getTrackCheckInById: async (id: number): Promise<AppTrackCheckIn> => {
        const response = await axios.get(`${API_URL}/getCheckInById/${id}`, { headers: authHeader() });
        return response.data;
    },

    createTrackCheckIn: async (trackCheckIn: Omit<AppTrackCheckIn, 'id' | 'created_time' | 'updated_time'>): Promise<AppTrackCheckIn> => {
        const response = await axios.post(`${API_URL}/add`, trackCheckIn, { headers: authHeader() });
        return response.data;
    },

    updateTrackCheckIn: async (id: number, trackCheckIn: Omit<AppTrackCheckIn, 'id' | 'created_time' | 'updated_time'>): Promise<AppTrackCheckIn> => {
        const response = await axios.put(`${API_URL}/update/${id}`, trackCheckIn, { headers: authHeader() });
        return response.data;
    },

    deleteTrackCheckIn: async (id: number): Promise<void> => {
        await axios.delete(`${API_URL}/delete/${id}`, { headers: authHeader() });
    }
};
